import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/lib/integration/react';
import router from './routes/mainRoutes';
import { persistor, store } from './store/store';
import './styles/main.scss';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const iconPath = white_label_perkeso ? '/perkeso_32x32.png' : '/elfo_A2P_fav icon_32x32.png';
const title = white_label_perkeso ? 'A2P SMS Platform' : 'elfoA2P';

ReactDOM.createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <Helmet>
      <title>{title}</title>
      <link rel="icon" type="image/png" href={iconPath} />
    </Helmet>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
  </HelmetProvider>
);
